import { render, staticRenderFns } from "./PaginationInfinite.vue?vue&type=template&id=f0e831bc&"
import script from "./PaginationInfinite.vue?vue&type=script&lang=js&"
export * from "./PaginationInfinite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports